<template >
    <b-card>
        <b-table
            :items="letras"
            :fields="columnasTable"
            class="table table-borderless"
            outlined
            striped
            responsive
            ref="tablePrevia"
            >
            <!-- table-borderless-->

            <!--<template #thead-top="data">
              <b-tr>
                <b-th variant="secondary" colspan="1">Terminado</b-th>
                <b-th variant="secondary" colspan="2">Mano</b-th>
                <b-th variant="primary" colspan="2">Confeccion</b-th>
              </b-tr>
            </template>-->

            <template v-for="(grupo,index) in gruposImagenes" v-slot:[`cell(${grupo.name})`]="data">
              <b-row style="position: relative; display: flex; justify-content: center;" :key="index">
                <span v-for="(item,index) in getGrupoImagenes(data.item, grupo.name)" :key="grupo.name+index">
                  <div class="container" style="margin-bottom: -15px;">
                    <p style="text-align: center; position: relative;top: 0%;">{{item.nombreCategoria}}</p>
                  </div>
                  <b-col cols="auto" style="margin: 2px; padding: 10px">
                    <div :class="{'div-imagenes': item.finalizado, 'div-proceso': item.iniciado, 'div-bloqueado': item.bloqueado} " style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%;" @click="tareaFinalizada(item)"></div>
                    <img :id='item.requierePrevio' :src="item.img" style="max-width: 100px;" alt="">
                  </b-col>
                </span>
              
              </b-row>
            </template>

            <template #cell(letraimg)="data">
              <p style="text-align: center"><b>{{data.item.letra}} - {{data.item.titulo}}</b></p>
                <div style="position: relative; display: flex; justify-content: center; align-items: center; padding: 10px">
                    <div :class="{'div-imagenes': data.item.finalizado, 'div-bloqueado': data.item.bloqueado} " style=" position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></div>
                    <img :src="data.item.img" style="max-width: 100px;" alt="">
                </div>
            </template>
        </b-table>
        <!--</div>-->
    </b-card>
</template>

<script>
import axios from '@axios'
/*import VueApexCharts from 'vue-apexcharts'*/
import { BTable, BFormInput, BFormGroup, BRow, BCol} from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex';

  export default {
    components: {
        BCardCode,
        BTable,
        BFormInput,
        BFormGroup,
        BRow,
        BCol,
        vSelect,
    },
    data () {
      return {
        columnasTable: [
        {
          key: "mano1",
          label: "Mano",
          sortable: true,
        },{
          key: "mano2",
          label: "Mano",
          sortable: true,
        },{
          key: "aparado1",
          label: "Aparado",
          sortable: true,
        },{
          key: "aparado2",
          label: "Aparado",
          sortable: true,
        },{
          key: "img",
          label: "Terminado",
          sortable: true,
        },{
          key: "options",
          label: "Reportes",
          thStyle: { width: "5%" },
        }],
        tareas: [],
        allTareas: [],
        coloresSku: [],
        colorSelect: null,
        listSku: [],
        skuSelect: null,
        skuConfeccion: [],
        tituloSelect: "",
        tareaReport: {nombreCategoria: ""},
        descripcionReport: "",
        reportTipo: 0,
        cantidadObjetivo: 0,
        cantidadCortada: 0,
        timer: "",
        countDown: 30,
        allLetras: [],
        letras: [],
        gruposImagenes: [],
        skuUrl: ''
      }
    },
    methods:{
      async loadItems(autoload = false){

        axios.post("/uso", {seccion:"vistaPreviaConfeccion"});
           axios
            .get("/confeccion/letra/sku/" + encodeURIComponent(this.skuUrl))
            .then(response => {
                return response.data;
            })
            .then(resLetras => {

              this.allLetras = resLetras;
              this.filtraLetras();

            });

      },
      eliminarUltimoApartado(cadena) {
            const lastIndex = cadena.lastIndexOf("-");
            if (lastIndex !== -1) {
                return cadena.substring(0, lastIndex);
            }
            return cadena;
      },
      tareaFinalizada(data){

        if (!data.finalizado) {
            data.iniciado = !data.iniciado;
            data.finalizado = !data.iniciado;
        } else {
            data.iniciado = false;
            data.finalizado = false;
        }

        this.allLetras.forEach(letra => {
          if (letra.id === data.idLetra) {
            letra.finalizado = letra.tareas.every(tarea => tarea.finalizado);
          }
        });

        this.$refs.tablePrevia.refresh();
      },
      filtraLetras(){
        this.letras = [];

        this.letras = this.allLetras;

        let maxMano = 0;
        let maxAparado = 0;

        this.letras.forEach(letra => {
          letra.grupos = {};
          let contadorMano = 0;
          let contadorAparado = 0;
          let lastTipo = "";
          letra.finalizado = false;

          letra.tareas.forEach(tarea => {
            let tipo = tarea.tipo;
            let contador = tipo === "Mano" ? contadorMano : contadorAparado;
            let grupo = tipo === "Mano" ? "mano" : "aparado";
            tarea.iniciado = false;
            tarea.finalizado = false;

            if (lastTipo === "") {
              contador++;
              letra.grupos[grupo + contador] = [tarea];
              lastTipo = tipo;
            } else if (lastTipo !== tipo) {
              contador++;
              letra.grupos[grupo + contador] = [tarea];
              lastTipo = tipo;
            } else {
              letra.grupos[grupo + contador].push(tarea);
            }

            if (tipo === "Mano") {
              contadorMano = contador;
            } else {
              contadorAparado = contador;
            }

          });

          if(contadorMano > maxMano)
            maxMano = contadorMano;
          if(contadorAparado > maxAparado)
            maxAparado = contadorAparado;
        });

        this.columnasTable = [];

        this.gruposImagenes = []    
        
         this.columnasTable.push({
          key: "letraimg",
          label: "Terminado",
          thClass: 'columnSeparador',
          tdClass: 'columnSeparador'
        });

        for (let index = 1; index <= maxMano; index++) {
          if(index == maxMano)
          {
              this.columnasTable.push({
                key: "mano"+index,
                label: "Mano",
                thClass: 'columnSeparador',
                tdClass: 'columnSeparador'
              })
          }
          else
          {
            this.columnasTable.push({
              key: "mano"+index,
              label: "Mano",
            })
          }
          
          this.gruposImagenes.push({name: "mano"+index})
        }

        

        for (let index = 1; index <= maxAparado; index++) {
         
            this.columnasTable.push({
              key: "aparado"+index,
              label: "Aparado",
            })
          
          

          this.gruposImagenes.push({name: "aparado"+index})
        }    
      },
      getGrupoImagenes(item, grupoName)
      {
        for (const [grupo, tareas] of Object.entries(item.grupos)) {
          if(grupo == grupoName)
            return tareas;
        }
      },
      checkBloqueados()
      {
        // Crear un diccionario o mapa para almacenar las tareas por su ID
          const tareaPorId = {};
          this.letras.forEach(letra => {
            letra.tareas.forEach(tarea => {
              tareaPorId[tarea.id] = tarea;
            });
          });

          // Iterar nuevamente para actualizar el estado de las tareas
          this.letras.forEach(letra => {
            letra.tareas.forEach(tarea => {
              if (tarea.requierePrevio !== 0) {
                const tareaBuscando = tareaPorId[tarea.requierePrevio];
                if (tareaBuscando) {
                  if (tareaBuscando.bloqueado) {
                    tarea.bloqueado = true;
                  }
                  else if (tareaBuscando.finalizado || tareaBuscando.iniciado) {
                    tarea.bloqueado = false;
                  } 
                }
              }
            });
          });

        this.letras.forEach(letra => {
          let auxBloqueado = false;
          for (let index = 0; index < letra.tareas.length - 1; index++) {
            if (letra.tareas[index].terminado === 0 && letra.tareas[index].iniciado === 0) {
              auxBloqueado = true;
              break;
            }
          }

          letra.tareas[letra.tareas.length - 1].bloqueado = auxBloqueado;
        });


        this.letras.forEach(letra => {

          let auxFinalizado = true;
          let auxBloqueado = true;
          for (const [grupo, tareas] of Object.entries(letra.grupos)) {
            tareas.forEach(tarea => {
              if(!tarea.finalizado)
                auxFinalizado=false;

              if(!tarea.bloqueado)
                auxBloqueado = false;

            });
          }

          letra.finalizado = auxFinalizado;
          letra.bloqueado = auxBloqueado;

        });
        /*console.log(this.letras);
        console.log(this.allTareas);*/
      },
    },
    mounted() {
      this.skuUrl = this.$route.params.id;
      this.loadItems();
    },
    computed: {
      ...mapGetters('app', ['confeccionUpdate']),
    },
  }
</script>

<style lang="scss">
  @import '../@core/scss/vue/libs/vue-select.scss';

  .btn-circle{
    border-radius: 20px;
    padding: 12px;
    margin-right: 10px;
  }

  .btn-options{
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .div-imagenes{
    background-color: rgba(124, 255, 130, 0.35) ;
    border-radius: 15px;
  }

  .option-select{
    /*border: 2px solid #000000 !important;*/
    font-weight: bold; 
    font-size: 16px;
    /*box-shadow: 1px 1px 1px 2px rgba(255,255,255,1);*/
    //border: 2px solid #ffffff81 !important;
    box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -webkit-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    -moz-box-shadow: 0px 1px 11px 2px rgba(142, 142, 142, 0.75) !important;
    //border-style: dotted !important;
  }

  .div-reporte{
    text-align: center;
    padding: 20px; 
    border-radius: 5px;
    border: 1px solid black;
  }

  .dark-layout .div-reporte{
    border: 1px solid white;
  } 

  .spinDisable button{
    display: none;
  }

  .div-imagenes-incompleta{
    background-color: rgba(255, 187, 78, 0.48);
  }

  .div-bloqueado{
    background-color: rgba(147, 147, 147, 0.48) !important;
    border-radius: 15px;
  }

  .div-proceso{
    background-color: rgba(255, 187, 78, 0.48);
    border-radius: 15px;
  }

  table th{
    text-align: center
  }

  .columnSeparador{      
    border-right: 5px solid #eeeeee !important;
  }
</style>